var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-container"},_vm._l((_vm.displayMessages),function(displayMessage,index){return _c('div',{key:index,class:['message-div']},[_c('img',{attrs:{"src":_vm.setMessageIcon(displayMessage.type),"alt":""}}),_vm._v(_vm._s(`${displayMessage.text}`))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }